export default {
  props: {
    ariaLabel: {
      type: String,
      default: ''
    }
  }
};